export default __webpack_public_path__ + "static/4-4bbf4256d450f6e0af6b9155bf34e010.jpg";